module.exports = __webpack_public_path__ + "cfb8bba82edc056bc957b8a39a8222b0.pdf";